module.exports = __webpack_public_path__ + "static/media/dash-icon.363f6e1b.svg";